import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { TeambookIcon } from "../default_images/TeambookIcon";
import { icons } from "../default_images/IconsList";
import { ClickAwayListener } from "@mui/base";
import PropTypes from "prop-types";
import { Portal } from "../planner/default_components/Portal";

const TeambookSortingTypes = ({
  filterOrder,
  setFilterOrder,
  style,
  className = "",
  dropdownOffsetBottom = 0,
  sortingTypes = [],
}) => {
  const { t } = useTranslation();
  const anchorRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const filterOptionMapping = [
    {
      type: "alphabetical",
      icon: icons.SORT_AZ,
      tooltip: t("sort_name_a"),
      setOrder: "firstname_a",
      id: "alphabeticalOrder",
      is_selected: filterOrder === "firstname_a",
      entity: "user",
    },
    {
      type: "alphabetical",
      icon: icons.SORT_ZA,
      tooltip: t("sort_name_z"),
      setOrder: "firstname_z",
      id: "alphabeticalOrder",
      is_selected: filterOrder === "firstname_z",
      entity: "user",
    },
    {
      type: "alphabetical",
      icon: icons.SORT_AZ,
      tooltip: t("sort_last_name_a"),
      setOrder: "lastname_a",
      id: "alphabeticalOrder",
      is_selected: filterOrder === "lastname_a",
      entity: "user",
    },
    {
      type: "alphabetical",
      icon: icons.SORT_ZA,
      tooltip: t("sort_last_name_z"),
      setOrder: "lastname_z",
      id: "alphabeticalOrder",
      is_selected: filterOrder === "lastname_z",
      entity: "user",
    },
    {
      type: "alphabetical",
      icon: icons.SORT_AZ,
      tooltip: t("actuals.sort_projects_a"),
      setOrder: "project_name_a",
      id: "projectNameOrder",
      is_selected: filterOrder === "project_name_a",
      entity: "project",
    },
    {
      type: "alphabetical",
      icon: icons.SORT_ZA,
      tooltip: t("actuals.sort_projects_z"),
      setOrder: "project_name_z",
      id: "projectNameOrder",
      is_selected: filterOrder === "project_name_z",
      entity: "project",
    },
    {
      type: "default",
      icon: icons.SORT_MY_ORDER,
      tooltip: t("planning.my_order"),
      setOrder: "default",
      id: "myOrder",
      is_selected: filterOrder === "default",
      entity: "default",
    },
    {
      type: "department",
      icon: icons.SORT_DEPARTMENT_A,
      tooltip: t("sort_department_a"),
      setOrder: "department_a",
      id: "departmentOrder",
      is_selected: filterOrder === "department_a",
      entity: "department",
    },
    {
      type: "department",
      icon: icons.SORT_DEPARTMENT_Z,
      tooltip: t("sort_department_z"),
      setOrder: "department_z",
      id: "departmentOrder",
      is_selected: filterOrder === "department_z",
      entity: "department",
    },
    {
      type: "approved",
      icon: icons.APPROVED_AZ,
      tooltip: t("actuals.sort_delta_a"),
      setOrder: "approved_a",
      id: "approvedOrder",
      is_selected: filterOrder === "approved_a",
      entity: "delta_hours",
    },
    {
      type: "approved",
      icon: icons.APPROVED_ZA,
      tooltip: t("actuals.sort_delta_z"),
      setOrder: "approved_z",
      id: "approvedOrder",
      is_selected: filterOrder === "approved_z",
      entity: "delta_hours",
    },
  ];

  const currentFilterOrder = filterOptionMapping.find((option) => option.is_selected) || filterOptionMapping[0];

  const openDropdown = () => {
    setDropdownOpen(true);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  const getSortOptions = () => {
    return filterOptionMapping.filter((option) => sortingTypes.includes(option.entity));
  };

  return (
    <div
      className="sorting-types__dropdown-container"
      style={{
        ...style,
      }}
      ref={anchorRef}
    >
      <div className={`sorting-types__dropdown-current-order ${className}`} onClick={openDropdown}>
        <TeambookIcon name={currentFilterOrder.icon} className="sorting-types__dropdown-current-order-icon" />
        <p>{currentFilterOrder.tooltip}</p>

        <TeambookIcon
          className="sorting-types__dropdown-arrow"
          name={icons.ARROW_DOWN}
          style={{ transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)" }}
        />
      </div>
      {dropdownOpen && (
        <Portal>
          <ClickAwayListener onClickAway={closeDropdown}>
            <div
              className="sorting-types__dropdown"
              style={{
                top:
                  anchorRef.current.getBoundingClientRect().top +
                  anchorRef.current.getBoundingClientRect().height +
                  1 +
                  dropdownOffsetBottom,
                left: anchorRef.current.getBoundingClientRect().left,
                width: anchorRef.current.getBoundingClientRect().width,
              }}
            >
              {getSortOptions().map((option, index) => (
                <div
                  className={`sorting-types__dropdown-option ${
                    option.is_selected ? "sorting-types__dropdown-option--selected" : ""
                  }`}
                  key={index}
                  onClick={() => {
                    setFilterOrder(option.setOrder);
                    closeDropdown();
                  }}
                >
                  <TeambookIcon name={option.icon} />
                  <p>{option.tooltip}</p>
                </div>
              ))}
            </div>
          </ClickAwayListener>
        </Portal>
      )}
    </div>
  );
};

TeambookSortingTypes.propTypes = {
  filterOrder: PropTypes.string.isRequired,
  setFilterOrder: PropTypes.func.isRequired,
  style: PropTypes.object,
  sortingTypes: PropTypes.array,
  className: PropTypes.string,
  dropdownOffsetBottom: PropTypes.number,
};

export default TeambookSortingTypes;
